import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Cryptocontext from "./components/Cryptocontext"

ReactDOM.render(
  <React.StrictMode>
    <Cryptocontext>
    <App />
    </Cryptocontext>
  </React.StrictMode>,
  document.getElementById('root')
);

